/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_PortugueseInputs */



/**
* | output |
* | --- |
* | "Portuguese" |
*
* @param {Speechmatics_Target_Language_PortugueseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_portuguese = /** @type {((inputs?: Speechmatics_Target_Language_PortugueseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_PortugueseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Portugais")
	if (locale === "de") return /** @type {LocalizedString} */ ("Portugiesisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("portoghese")
	if (locale === "ru") return /** @type {LocalizedString} */ ("португальский")
	if (locale === "es") return /** @type {LocalizedString} */ ("portugués")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("葡萄牙语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ポルトガル語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुर्तगाली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Português")
	return /** @type {LocalizedString} */ ("Portuguese")
});